import { render, staticRenderFns } from "./waitDealFeedback.vue?vue&type=template&id=96221976&"
import script from "./waitDealFeedback.vue?vue&type=script&lang=js&"
export * from "./waitDealFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports